import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo2.jpg';
const _hoisted_1 = {
  class: "login_layout"
};
const _hoisted_2 = {
  class: "login_content"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "logo_title"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}), /*#__PURE__*/_createTextVNode(" 翠微旅居云平台 ")], -1);

const _hoisted_4 = {
  class: "login"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "login_title"
}, "用 户 登 录", -1);

import { ref, watch } from "vue";
import accout from "@api/accout";
import event from "@util/eventBus";
import auth from "@net/auth";
import { User, Lock } from "@element-plus/icons-vue";
export default {
  __name: 'LoginView',

  setup(__props) {
    let defaultName = null;
    let defaultPassword = null;

    if (process.env.NODE_ENV === "development") {
      defaultName = "admin";
      defaultPassword = "123456";
    }

    const name = ref(defaultName);
    const password = ref(defaultPassword);

    function login() {
      accout.login(name.value, password.value, val => {
        auth.setToken(val.accessToken);
        event.sendEvent("LOGIN");
        location.reload();
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_input, {
        class: "login_input",
        "prefix-icon": _unref(User),
        modelValue: name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
        size: "large",
        clearable: ""
      }, null, 8, ["prefix-icon", "modelValue"]), _createVNode(_component_el_input, {
        class: "login_input",
        "prefix-icon": _unref(Lock),
        modelValue: password.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => password.value = $event),
        type: "password",
        size: "large",
        clearable: ""
      }, null, 8, ["prefix-icon", "modelValue"]), _createElementVNode("div", {
        class: "login_but",
        onClick: _cache[2] || (_cache[2] = $event => login())
      }, "登 录")])])]);
    };
  }

};